export const helpersMixin = {
    data: function () {
        return {
            auth_user: window.auth_user,
            carbon_year: window.carbon_year,
            csrf_field: window.csrf_field,
            route_name: window.route_name
        }
    },
    computed: {
        is_authenticated: function(){
            return typeof auth_user === 'object';
        },
    },
    filters: {
        toLocaleString: function(number){
            if(!number){
                return 0;
            }
            return number.toLocaleString();
        },
        shortenNumber: function(number){
            if(number == undefined){
                return '-';
            }
            if(!number){
                return 0;
            }
            if(number < 10000){
                return number.toLocaleString();
            }

            var symbols = ["", "k", "M", "B", "T"];

            var tier = Math.log10(number) / 3 | 0;
            if(tier == 0){
                return number;
            } else if(tier > 4){
                tier = 4;
            }

            var suffix = symbols[tier];
            var scale = Math.pow(10, tier * 3);
            var scaled = number / scale;

            var toFixed = function(num, fixed){
                var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
                return num.toString().match(re)[0];
            }
            return toFixed(scaled, 1) + suffix;
        }
    },
    methods:{
        ucFirst: function(string){
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        textTruncate: function(str, length, ending) {
            if (length == null) {
                length = 100;
            }
            if (ending == null) {
                ending = '...';
            }
            if (str && str.length > length) {
                return str.substring(0, length - ending.length) + ending;
            } else {
                return str;
            }
        },
        formatDate: function(date, format){
            if(!date){
                return;
            }
            var timezone = moment.tz.guess();
            return moment.tz(date, 'UTC').tz(timezone).format(format);
        },
        formatDateWithoutTimezone: function(date, format){
            if(!date){
                return;
            }
            return moment(date).format(format);
        },
        get: function(object, key, default_value){
            return _.get(object, key, default_value);
        },
        showMessage: function(text){
            if(typeof window.Snackbar === 'object'){
                Snackbar.show({
                    text: text,
                    pos: 'top-center',
                    duration: 6000
                });
            } else {
                alert(text);
            }
        },
        showErrorMessage: function (error, options) {
            var text = 'An error has occurred';
            options = options || {};
            var duration = 6000;
            if(options.duration >= 0){
                duration = options.duration;
            }
            
            if(error && error.response && error.response.data){
                if (error.response.data.error && error.response.data.error.validator_messages) {
                    text = error.response.data.error.validator_messages[0];
                } else if (error.response.data.exception && error.response.data.exception.message) {
                    text = error.response.data.exception.message;
                }
            }
            if(typeof window.Snackbar === 'object'){
                Snackbar.show({
                    text: text,
                    customClass: 'error',
                    pos: 'top-center',
                    duration: duration
                });
            } else {
                alert(text);
            }
        },
        getPercentage: function (number, precision) {
            if (!number) {
                return 0;
            }
            precision = precision || 2;
            return (number * 100).toFixed(2);
        },
        setSort: function (obj, key, dir) {
            var current_sort = obj.order_by;
            if (current_sort === key) {
                //flip direction
                if (obj.order_dir === 'asc') {
                    Vue.set(obj, 'order_dir', 'desc');
                } else {
                    Vue.set(obj, 'order_dir', 'asc');
                }
            } else {
                //new key, start with asc
                Vue.set(obj, 'order_by', key);
                dir = dir || 'desc';
                Vue.set(obj, 'order_dir', dir);
            }

            if (obj.sort_callback) {
                if(obj.pagination){
                    obj.pagination.page = 1;
                }
                obj.sort_callback();
            }
        },
        getRandomString: function(length) {
            length = length || 24;
            var str = '';
            var characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            var characters_length = characters.length;
            for(var i = 0; i < length; i++ ) {
                str += characters.charAt(Math.floor(Math.random() * characters_length));
            }
            return str;
        },
        initIntersection: function(el, cb){
            if(!el){
                return;
            }
            var self = this;
            if(!this.io){
                this.io = new IntersectionObserver(entries => {
                    entries.forEach(function(entry) {
                        if(entry.isIntersecting){
                            let target = entry.target;
                            if(!target.__loaded && target.__cb){
                                target.__cb();
                                target.__loaded = true;
                                self.io.unobserve(target);
                            }
                        }
                    });
                }, {});
            }

            el.__loaded = false;
            el.__cb = cb;
            this.io.observe(el);
        },
        formatTextEntities: function (text) {
            if(!text){
                return text;
            }

            //Replace special characters
            text = text.replaceAll('&lt;', '<');
            text = text.replaceAll('&gt;', '>');
            text = text.replaceAll('&amp;', '&');

            //Email
            var regex = /([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)/gmi;
            text = text.replaceAll(regex, '<a href="mailto:$1" target="_blank" title="$1">$1</a>');

            //Add http to urls starting with www
            var words = text.split(' ');
            words = words.map(function(word){
                if(word && word.substring(0, 4) === 'www.'){
                    word = 'http://' + word;
                }
                return word;
            });
            text = words.join(' ');                

            //Urls
            regex = /(https?:\/\/((?:\w+.)?\w+\.\w{2,3}[\/\w@\.\-\?&=]*))/gmi;
            text = text.replaceAll(regex, '<a href="$1" target="_blank" title="$2">$2</a>');

            //Hashtags
            regex = /(#(\w+))/gmi;
            text = text.replaceAll(regex, '<a href="/hashtag/$2" title="$1">$1</a>');

            //Mentions
            regex = /\B(@([\w\.]+\b))/gmi;
            text = text.replace(regex, `<a href="/mention/$2" title="$1">$1</a>`);
            return text;
        },
        getSentimentText: function(score){
            if(typeof score !== 'number'){
                return;
            }
            if(score > 0.5){
                return 'Very Positive';
            } else if(score > 0.1){
                return 'Positive';
            } else if(score > -0.1){
                return 'Neutral';
            } else if(score > -0.5){
                return 'Negative';
            } else {
                return 'Very Negative';
            }
        }
    }
}


// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/mixins/helpersMixin.js